import { isDevelopmentEnvironment } from "@/lib/is-development-environment";

import { FeatureFlagIDs } from "../models/config";

import { useFeatureFlagSimple } from "./api/use-feature-flag-simple";

interface UseIsFeatureFlagOnProps {
  flag: FeatureFlagIDs;
  isInverted?: boolean;
  isDevelopmentBypassAllowed?: boolean;
}

interface UseIsFeatureFlagOnResult {
  isOn: boolean;
  isLoading: boolean;
}

export const useIsFeatureFlagOn = ({
  flag,
  isInverted = false,
  isDevelopmentBypassAllowed = true,
}: UseIsFeatureFlagOnProps): UseIsFeatureFlagOnResult => {
  const { isEnabled, loading } = useFeatureFlagSimple({ id: flag });

  const isEffectiveEnabled = isInverted ? !isEnabled : isEnabled;
  const isDevelopmentBypass = isDevelopmentBypassAllowed && isDevelopmentEnvironment();

  return { isOn: isEffectiveEnabled || isDevelopmentBypass, isLoading: loading };
};
